import { getPageInfoFromRouter } from '@/utils/getXyHeaders';
export function isOffline() {
    return !!window.xy_is_offline;
}
export function getPageIdFromWindow() {
    const pageId = window.RUNTIME_CONFIGS?.pageId || '';
    if (pageId)
        return pageId;
    return getPageInfoFromRouter().pageId || '';
}
;
export function getEnvIdFromWindow() {
    return window.w.env;
}
export function getProjectIdFromWindow() {
    return window.w.projectId;
}
export function getGlobalInfo() {
    return window.GLOBAL_INFO || {};
}
export function getBaseURL() {
    const { pathPrefix } = getGlobalInfo();
    // 给url添加host
    let fixPrefix = pathPrefix;
    if (!/^(http:|https:|\/\/)/.test(fixPrefix)) {
        // 适配 micro-app 微前端
        // @ts-ignore
        const MICRO_APP_ORIGIN = window.__MICRO_APP_PUBLIC_PATH__ ? new URL(window.__MICRO_APP_PUBLIC_PATH__).origin || '' : '';
        if (MICRO_APP_ORIGIN) {
            fixPrefix = `${MICRO_APP_ORIGIN}${fixPrefix}`;
        }
        else {
            fixPrefix = `//${location.host}${fixPrefix}`;
        }
    }
    return fixPrefix;
}
;
